import {
  AbandonedCartConfigResponseSchema,
  type AbandonedCartConfigResponse,
} from "@codway-dev/shared";
import { AuthService } from "./auth.service";

const API_BASE_URL = "/api";

async function authedFetch(
  path: string,
  init?: RequestInit
): Promise<Response> {
  const token = await AuthService.getShopifyToken();
  if (!token) throw new Error("No Shopify token available");
  return fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...init?.headers,
    },
  });
}

export const AbandonedCartService = {
  getConfig: async (): Promise<AbandonedCartConfigResponse> => {
    const res = await authedFetch("/admin/abandoned-cart/config");
    if (!res.ok)
      throw new Error(
        `Failed to load abandoned cart config: ${res.statusText}`
      );
    return AbandonedCartConfigResponseSchema.parse(await res.json());
  },

  updateConfig: async (
    enabled: boolean
  ): Promise<AbandonedCartConfigResponse> => {
    const res = await authedFetch("/admin/abandoned-cart/config", {
      method: "PUT",
      body: JSON.stringify({ enabled }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(
        `Failed to update abandoned cart config: ${(err as any).message ?? res.statusText}`
      );
    }
    return AbandonedCartConfigResponseSchema.parse(await res.json());
  },
};
